import { apiClient } from '@/lib/api-client';

export interface DashboardStats {
  delivery24h: {
    total: number;
    sent: number;
    failed: number;
    queued: number;
    skipped: number;
    emailTotal: number;
    whatsappTotal: number;
    inAppTotal: number;
  };
  activeProfiles: number;
  activeTemplates: number;
}

export const dashboardApi = {
  stats(): Promise<DashboardStats> {
    return apiClient.get('/admin/dashboard/stats');
  },
};
